{
  "alert": "Varning",
  "dismiss": "Avvisa"
}